import { useState, useEffect } from 'react';
import NannyCard from '../components/NannyCard';
import { supabase } from '../supabase';

export default function Home({ go, onBook }) {
  const [nannies, setNannies] = useState([]);

  useEffect(() => {
    async function fetchNannies() {
      const { data } = await supabase.from('nannies').select('*').eq('available', true).limit(3);
      setNannies(data || []);
    }
    fetchNannies();
  }, []);

  return (
    <div>
      <style>{`
        .hero-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; align-items: center; }
        .hero-visual { display: block; }
        .steps-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1px; background: rgba(255,255,255,.08); }
        .services-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 1.5rem; }
        .nanny-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 1.25rem; }
        .trust-bar { display: flex; flex-wrap: wrap; gap: 1rem; align-items: center; justify-content: space-between; }
        .promise-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 2rem; }
        .testimonials-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 1.5rem; }
        .cta-grid { display: grid; grid-template-columns: 1fr auto; align-items: center; gap: 40px; }
        .hero-stats { display: flex; gap: 2rem; padding-top: 2rem; border-top: 1px solid var(--border); }
        .hero-btns { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 2.5rem; }

        @media (max-width: 768px) {
          .hero-grid { grid-template-columns: 1fr; gap: 2rem; }
          .hero-visual { display: none; }
          .steps-grid { grid-template-columns: 1fr 1fr; }
          .promise-grid { grid-template-columns: 1fr 1fr; gap: 1.5rem; }
          .cta-grid { grid-template-columns: 1fr; text-align: center; }
          .cta-grid button { width: 100%; }
          .trust-bar { justify-content: flex-start; gap: .75rem; }
        }

        @media (max-width: 480px) {
          .steps-grid { grid-template-columns: 1fr; }
          .promise-grid { grid-template-columns: 1fr; }
          .hero-stats { gap: 1.5rem; }
          .hero-btns { flex-direction: column; }
          .hero-btns button { width: 100%; }
        }
      `}</style>

      {/* HERO */}
      <div style={{ background:'var(--warm)', padding:'60px 1.5rem 60px' }}>
        <div className="container">
          <div className="hero-grid">
            <div>
              <div style={{ display:'inline-flex', alignItems:'center', gap:8, background:'var(--teal-light)', color:'var(--teal-dark)', borderRadius:20, padding:'6px 16px', fontSize:13, fontWeight:600, marginBottom:'1.5rem' }}>
                <span className="pulse-dot"/> Calgary's Trusted Childcare Agency
              </div>
              <h1 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'clamp(34px,6vw,58px)', lineHeight:1.12, color:'var(--teal-deeper)', marginBottom:'1.25rem' }}>
                Find a nanny you can<br/><em style={{ color:'var(--coral)', fontStyle:'italic' }}>truly trust.</em>
              </h1>
              <p style={{ fontSize:16, color:'var(--text-mid)', lineHeight:1.75, marginBottom:'2rem', maxWidth:480 }}>
                We match Calgary families with vetted, background-checked caregivers. Every nanny passes our 7-point verification — no shortcuts, ever.
              </p>
              <div className="hero-btns">
                <button className="btn-primary" onClick={() => go('nannies')}>Find a nanny</button>
                <button className="btn-outline" onClick={() => go('consult')}>Book a free consult</button>
              </div>
              
            </div>
            <div className="hero-visual" style={{ background:'var(--teal-light)', borderRadius:24, padding:'2rem' }}>
              <div style={{ background:'white', borderRadius:16, padding:'1.25rem 1.5rem', border:'1px solid var(--border)', marginBottom:'1rem' }}>
                <div style={{ display:'inline-block', background:'var(--teal)', color:'white', borderRadius:6, padding:'3px 10px', fontSize:11, fontWeight:700, marginBottom:'.75rem' }}>VERIFIED CAREGIVERS</div>
                <h4 style={{ fontSize:15, fontWeight:600, marginBottom:'.25rem' }}>Personally vetted by Ebere</h4>
                <p style={{ fontSize:13, color:'var(--text-light)' }}>Background-checked · CPR certified · References verified</p>
                <div style={{ display:'flex', gap:'1rem', marginTop:'.75rem', fontSize:12, color:'var(--teal-dark)', fontWeight:500 }}>
                  <span>🛡️ Fully screened</span><span>❤️ Trusted</span>
                </div>
              </div>
              <div style={{ display:'flex', gap:'.75rem', justifyContent:'center', alignItems:'center', padding:'1rem', background:'rgba(255,255,255,.5)', borderRadius:12 }}>
                <div style={{ fontSize:13, color:'var(--teal-dark)', fontWeight:600, textAlign:'center' }}>
                  {nannies.length > 0 ? `${nannies.length} caregiver${nannies.length>1?'s':''} available` : 'Caregivers being onboarded'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* TRUST BAR */}
      <div style={{ background:'var(--teal-deeper)', padding:'16px 1.5rem' }}>
        <div className="container">
          <div className="trust-bar">
            {[['🛡️','Vulnerable Sector Check'],['🩺','CPR Level C & First Aid'],['👶','Child Abuse Registry'],['❤️','Vetted by Ebere'],['🪪','Licence TN28080273']].map(([i,t]) => (
              <div key={t} style={{ display:'flex', alignItems:'center', gap:6 }}>
                <span style={{ fontSize:14 }}>{i}</span>
                <span style={{ fontSize:12, color:'var(--teal-mid)', fontWeight:500 }}>{t}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* HOW IT WORKS */}
      <div style={{ background:'var(--teal-deeper)', padding:'64px 1.5rem' }}>
        <div className="container">
          <div style={{ fontSize:12, fontWeight:700, letterSpacing:2, color:'var(--teal-mid)', textTransform:'uppercase', marginBottom:10 }}>Simple process</div>
          <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'clamp(26px,4vw,44px)', color:'white', marginBottom:12 }}>How we find your perfect nanny</h2>
          <p style={{ fontSize:15, color:'var(--teal-mid)', lineHeight:1.7, maxWidth:560, marginBottom:'3rem' }}>We handle all the hard work — vetting, matching, introductions, and compliance — so you can focus on your family.</p>
          <div className="steps-grid">
            {[['💬','1','Tell us what you need','Fill out our short form — schedule, children\'s ages, and any special requirements.'],['🔍','2','We match you','Ebere hand-selects caregivers from our roster who fit your family.'],['❤️','3','Meet your caregiver','Browse profiles, review credentials, and connect.'],['🏠','4','They\'re in good hands','Your child is cared for by someone you trust. We stay available for support.']].map(([icon,n,t,d]) => (
              <div key={n} style={{ background:'var(--teal-deeper)', padding:'2rem 1.5rem', textAlign:'center', borderTop:'1px solid rgba(255,255,255,.08)' }}>
                <div style={{ fontSize:28, marginBottom:10 }}>{icon}</div>
                <div style={{ width:40, height:40, borderRadius:'50%', background:'var(--teal)', color:'white', fontFamily:"'DM Serif Display',serif", fontSize:18, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 1rem' }}>{n}</div>
                <h4 style={{ fontSize:15, fontWeight:700, color:'white', marginBottom:'.5rem' }}>{t}</h4>
                <p style={{ fontSize:13, color:'var(--teal-mid)', lineHeight:1.6 }}>{d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* SERVICES */}
      <div style={{ padding:'64px 1.5rem', background:'white' }}>
        <div className="container">
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end', marginBottom:'2.5rem', flexWrap:'wrap', gap:16 }}>
            <div>
              <div className="sec-label">What we offer</div>
              <h2 className="sec-title">Our care services</h2>
            </div>
            <button className="btn-outline" style={{ fontSize:14, padding:'10px 20px' }} onClick={() => go('consult')}>Request a service →</button>
          </div>
          <div className="services-grid">
            {[
              ['👶','Full-time nanny','Daily childcare — school pickups, homework help, nutritious meals, activities, and bedtime routines.','Nanny rates: $18–$25/hr'],
              ['🧠','Special needs care','Experienced support for children with autism, Down syndrome, FASD, and complex needs.','Nanny rates: $20–$30/hr'],
              ['🌙','Overnight & weekend care','Evening babysitting, overnight stays, and full weekend care.','Nanny rates: $22–$28/hr'],
              ['🏠','After-school program','School pickup, healthy snacks, homework support, and engaging activities.','Nanny rates: $16–$22/hr'],
              ['🧹','Household support','Light housekeeping, meal prep, laundry, and errands alongside childcare.','Nanny rates: $18–$24/hr'],
              ['🍼','Newborn & infant care','Gentle, nurturing care for your littlest ones — feeding routines, sleep support, and more.','Nanny rates: $20–$26/hr'],
            ].map(([icon,title,desc,price]) => (
              <div key={title} style={{ background:'white', border:'1px solid var(--border)', borderRadius:16, padding:'1.5rem', transition:'transform .2s,box-shadow .2s' }}
                onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-4px)';e.currentTarget.style.boxShadow='0 12px 30px rgba(0,0,0,.07)';}}
                onMouseLeave={e=>{e.currentTarget.style.transform='none';e.currentTarget.style.boxShadow='none';}}>
                <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:'1rem' }}>
                  <div style={{ width:44, height:44, borderRadius:12, background:'var(--teal-light)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:20, flexShrink:0 }}>{icon}</div>
                </div>
                <h4 style={{ fontSize:16, fontWeight:700, marginBottom:'.5rem' }}>{title}</h4>
                <p style={{ fontSize:13, color:'var(--text-mid)', lineHeight:1.65, marginBottom:'1rem' }}>{desc}</p>
                <div style={{ fontSize:13, fontWeight:600, color:'var(--teal)' }}>{price}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FEATURED NANNIES */}
      <div style={{ padding:'64px 1.5rem', background:'var(--warm)' }}>
        <div className="container">
          <div className="sec-label">Hand-picked</div>
          <h2 className="sec-title">Meet some of our caregivers</h2>
          <p className="sec-sub" style={{ marginBottom:'2.5rem' }}>Every caregiver is personally vetted by our founder — background checked, reference verified, and interview approved.</p>
          {nannies.length > 0 ? (
            <>
              <div className="nanny-grid">
                {nannies.map(n => <NannyCard key={n.id} n={n} onBook={onBook}/>)}
              </div>
              <div style={{ textAlign:'center', marginTop:32 }}>
                <button className="btn-outline" onClick={() => go('nannies')}>See all caregivers →</button>
              </div>
            </>
          ) : (
            <div style={{ textAlign:'center', padding:'3rem 1.5rem', background:'white', borderRadius:16, border:'1px solid var(--border)' }}>
              <div style={{ fontSize:48, marginBottom:16 }}>👩</div>
              <h3 style={{ fontFamily:"'DM Serif Display',serif", fontSize:22, color:'var(--teal-deeper)', marginBottom:12 }}>Caregivers coming soon</h3>
              <p style={{ fontSize:15, color:'var(--text-mid)', marginBottom:24 }}>Contact us directly and we'll find the perfect match for your family.</p>
              <button className="btn-primary" onClick={() => go('consult')}>Contact us →</button>
            </div>
          )}
        </div>
      </div>

      {/* TESTIMONIALS */}
      <div style={{ padding:'64px 1.5rem', background:'white' }}>
        <div className="container">
          <div className="sec-label">What families say</div>
          <h2 className="sec-title">Trusted by Calgary families</h2>
          <div className="testimonials-grid" style={{ marginTop:'2.5rem' }}>
            {[
              ['"','Ebere went above and beyond to find us someone who truly understood our daughter\'s needs. Within days we had a nanny who felt like family. The background check process gave us complete peace of mind.','The Morrison Family','NW Calgary · Full-time placement'],
              ['"','As a single mom working shifts, I needed someone I could genuinely trust. Tinytrust has been a lifeline. Ebere personally called me to talk through my situation before suggesting anyone.','Daniela R.','NE Calgary · Ongoing placement'],
              ['"','Our son has autism and finding the right support worker felt impossible — until we found Tinytrust. Monica has been incredible. The matching process was thorough and caring from start to finish.','The Okonkwo Family','SE Calgary · Special needs placement'],
            ].map(([q,text,name,sub]) => (
              <div key={name} style={{ background:'var(--warm)', border:'1px solid var(--border)', borderRadius:16, padding:'1.75rem' }}>
                <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:40, color:'var(--teal-light)', lineHeight:1, marginBottom:12 }}>{q}</div>
                <p style={{ fontSize:14, color:'var(--text-mid)', lineHeight:1.75, fontStyle:'italic', marginBottom:'1.25rem' }}>{text}</p>
                <div style={{ color:'#F5A623', fontSize:14, marginBottom:8 }}>★★★★★</div>
                <div style={{ fontWeight:700, fontSize:14 }}>{name}</div>
                <div style={{ fontSize:12, color:'var(--text-light)', marginTop:2 }}>{sub}</div>
                <div style={{ fontSize:11, color:'var(--teal)', fontWeight:600, marginTop:4 }}>✓ Verified placement through Tinytrust</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* THE PROMISE */}
      <div style={{ padding:'64px 1.5rem', background:'var(--warm)' }}>
        <div className="container">
          <div style={{ textAlign:'center', marginBottom:'2.5rem' }}>
            <div className="sec-label" style={{ textAlign:'center' }}>Why Tinytrust</div>
            <h2 className="sec-title" style={{ textAlign:'center' }}>The Tinytrust promise</h2>
          </div>
          <div className="promise-grid">
            {[['🛡️','Fully verified','VSC, Child Abuse Registry, Criminal Record Check — every caregiver, no shortcuts.'],['❤️','Personally vetted by Ebere','No caregiver joins without a personal interview with our founder — ever.'],['🩺','CPR & First Aid trained','All caregivers hold current CPR Level C with AED and First Aid certification.'],['🤝','Ongoing support','We stay available for check-ins, replacements, and support throughout your placement.']].map(([i,t,d]) => (
              <div key={t} style={{ textAlign:'center' }}>
                <div style={{ fontSize:36, marginBottom:12 }}>{i}</div>
                <h4 style={{ fontSize:15, fontWeight:600, color:'var(--teal-deeper)', marginBottom:8 }}>{t}</h4>
                <p style={{ fontSize:13, color:'var(--text-mid)', lineHeight:1.65 }}>{d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA BANNER */}
      <div style={{ background:'var(--teal-deeper)', padding:'56px 1.5rem' }}>
        <div className="container">
          <div className="cta-grid">
            <div>
              <div style={{ fontSize:12, fontWeight:700, letterSpacing:2, color:'var(--teal-mid)', textTransform:'uppercase', marginBottom:12 }}>Free consultation</div>
              <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'clamp(24px,4vw,40px)', color:'white', lineHeight:1.2 }}>Not sure where to start?<br/><em>We'll guide you.</em></h2>
            </div>
            <button className="btn-coral" style={{ whiteSpace:'nowrap', padding:'14px 32px', fontSize:15 }} onClick={() => go('consult')}>Talk to an Expert →</button>
          </div>
        </div>
      </div>
    </div>
  );
}